import { getLocalStorage, setLocalStorage } from '@omnia/ui/src/lib'
import type { CmsRichText } from '@omnia/ui/src/lib/cms/types/cmsRichText'
import { Icon } from '@vista-digital/occ-ui'
import { useState } from 'react'
import { IconButton } from '@/common/components/iconButton/IconButton'
import { RichText } from '@/common/components/richText/RichText'

interface NotificationBannerProps {
    id: string
    iconName?: string
    message: CmsRichText
}

export const NotificationBanner = ({ id, iconName, message }: NotificationBannerProps) => {
    const [isVisible, setIsVisible] = useState(true)

    const closeNotification = () => {
        const closedBanners = getLocalStorage<string[]>('closedBanners') ?? []
        closedBanners.push(id)
        setLocalStorage('closedBanners', closedBanners)
        setIsVisible(false)
    }

    if (!isVisible) return null
    return (
        <div className="notification-banner">
            {iconName && <Icon name={iconName} />}
            <RichText text={message} />
            <IconButton iconName="cross" onClick={closeNotification} />
        </div>
    )
}
